import(/* webpackMode: "eager", webpackExports: ["PageTeam"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/team/__page__/PageTeam.tsx");
